<link _ngcontent-mon-1="" href="//maxcdn.icons8.com/fonts/line-awesome/css/line-awesome.min.css" rel="stylesheet" type="text/css">

<script src="https://code.jquery.com/jquery-1.12.4.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script src="~/Home/Wizard/XapEmailValidate/js/emailvalidate.js"></script>

<form novalidate (ngSubmit)="onSubmit(f)" #f="ngForm" class="form-horizontal form-xs-wrap" (keydown)="onEnterKey($event)">
  <div id="create-account">
    <input type="hidden" id="nextpage" class="form-control" name="nextpage" />

    <div class="row" *ngIf="!isPopulated">
      <div class="loading-spinner" style="text-align: center;">

        <p>Loading...</p>
        <i class="fa fa-spin fa-spinner fa-3x fa-fw" aria-hidden="true"></i>
      </div>
    </div>
    <div class="panel panel-default" *ngIf="(config.SystemKey?.Visible && !isCodeActivated)">
      <div class="panel-heading">
        <h3>Activation Code</h3>
        <hr />
      </div>
      <div class="panel-body">
        <p>
          {{config.SystemKey?.Text}}
        </p>
        <div class="col-xs-12 offset-4 col-sm-5 col-sm-offset-4 col-md-5 col-md-offset-4 col-lg-5 col-lg-offset-4 col-xl-5 col-xl-offset-4 paddingT15">
          <label for="SystemKey" class="control-label">Activation code</label>
          <div class="input-group">
            <div class="input-tooltip">
              <input type="text" id="SystemKey" [(ngModel)]="systemKey" name="systemKey" class="form-control" size=10 maxlength=25 />
            </div>
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary inline" (click)="submitActivationCode(); $event.preventDefault()">
                <i class="fa fa-check" aria-hidden="true"></i> Submit
              </button>
            </span>
          </div>
          <p *ngIf="isInvalidActivationCode" class="error-message">
            <i class="fa fa-times" aria-hidden="true"></i> Please enter a valid Activation Code to continue.
          </p>
        </div>
      </div>
    </div>

    <div [hidden]="(!isCodeActivated && config.SystemKey?.Visible) || !isPopulated ">
      <div class="panel panel-default">
        <div class="panel-heading" *ngIf="config.UserRole?.Visible || config.FirstName?.Visible || config.MiddleName?.Visible || config.LastName?.Visible || config.DateOfBirth?.Visible || config.SelectSchool?.Visible">
          <h3>Your Information</h3>
          <hr />
        </div>
        <div class="panel-body">
          <div class="flex-container wrap" *ngIf="config.UserRole?.Visible" [ngClass]="{'has-error': (selectedRole.invalid && (selectedRole.dirty || selectedRole.touched || invalidForm ))}">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="UserRole" class="control-label">Who are you?</label>
              <div class="input-tooltip">
                <select id="UserRole" name="UserRole" placeholder="Select your role" class="form-control" [(ngModel)]="selectedRoleValue" [dynamicRequired]="f.controls['UserRole']" [isRequired]="true" [ignoreDefaultValue]="-1" #selectedRole="ngModel" [attr.aria-invalid]="(selectedRole.invalid && (selectedRole.dirty || selectedRole.touched || invalidForm ))"
                        (change)="onRoleChange()">
                  <option value="-1" disabled selected="selected">Select your role</option>
                  <option value="{{RolesEnum.MiddleSchool}}"> Middle school or junior high school student</option>
                  <option value="{{RolesEnum.HighSchool}}"> High school student</option>
                  <option value="{{RolesEnum.PostSecondary}}"> College or postsecondary school student</option>
                  <option value="{{RolesEnum.Adult}}"> Adult</option>
                  <option value="{{RolesEnum.Parent}}"> Parent</option>
                </select>
              </div>
              <div *ngIf="selectedRole.invalid && (selectedRole.dirty || selectedRole.touched || invalidForm)">
                <p class="error-message" *ngIf="selectedRole.errors?.dynamicRequired"><i class="fa fa-times" aria-hidden="true"></i> Please select your role.</p>
              </div>
            </div>
          </div>
          <div class="question-section-divider marginT20 marginB20" *ngIf="config.UserRole?.Visible"></div>
          <div class="flex-container wrap">
            <div [ngClass]="{'has-error': (firstName.invalid && (firstName.dirty || firstName.touched || invalidForm))}" *ngIf="config.FirstName?.Visible && !isCoppaRestricted" [style.display]="(hideNames)?'none':'block'">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="FirstName" class="control-label">First name</label>
                <div class="input-tooltip">
                  <input type="text" id="FirstName" [(ngModel)]="firstNameValue" name="firstName" class="form-control" [maxlength]="32" [dynamicRequired]="f.controls['firstName']" [isRequired]="true" #firstName="ngModel" [attr.aria-invalid]="(firstName.invalid && (firstName.dirty || firstName.touched || invalidForm))"
                         autocomplete="given-name">
                </div>
                <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched || invalidForm)">
                  <p class="error-message" *ngIf="firstName.errors?.dynamicRequired"><i class="fa fa-times" aria-hidden="true"></i> Please enter your first name.</p>
                </div>
              </div>
            </div>
            <div *ngIf="config.MiddleName?.Visible && !isCoppaRestricted">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="MiddleName" class="control-label">Middle name <span class="help">(optional)</span></label>
                <div class="input-tooltip">
                  <input type="text" id="MiddleName" [(ngModel)]="middleNameValue" [maxlength]="32" name="middleName" class="form-control" autocomplete="additional-name">
                </div>
              </div>
            </div>
          </div>
          <div class="flex-container wrap">
            <div [ngClass]="{'has-error': (lastName.invalid && (lastName.dirty || lastName.touched || invalidForm))}" *ngIf="config.LastName?.Visible && !isCoppaRestricted" [style.display]="(hideNames)?'none':'block'">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="LastName" class="control-label">Last name</label>
                <div class="input-tooltip">
                  <input type="text" id="LastName" [(ngModel)]="lastNameValue" [maxlength]="32" name="lastName" class="form-control" [dynamicRequired]="f.controls['lastName']" [isRequired]="true" #lastName="ngModel" [attr.aria-invalid]="(lastName.invalid && (lastName.dirty || lastName.touched || invalidForm))"
                         autocomplete="family-name">
                </div>
                <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched || invalidForm)">
                  <p class="error-message" *ngIf="lastName.errors?.dynamicRequired"><i class="fa fa-times" aria-hidden="true"></i> Please enter your last name.</p>
                </div>
              </div>
            </div>
            <div *ngIf="config.DateOfBirth?.Visible && (config.DateOfBirth?.Roles.indexOf(selectedRoleValue) !== -1) || (config.DateOfBirth?.Visible && !config.UserRole?.Visible)" [ngClass]="{'has-error': (dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="DateOfBirth" class="control-label">Date of birth</label>
                <div class="input-tooltip">
                  <input [textMask]="{mask: dateMask}" type="tel" id="DateOfBirth" [(ngModel)]="dateOfBirthValue" (change)="checkCoppaDate()" [validDob]="f.controls['dateOfBirth']" [minAgeDob]="f.controls['dateOfBirth']" [coppaDob]="config.CoppaRestricted?.Required" name="dateOfBirth"
                         class="form-control" placeholder="mm/dd/yyyy" #dateOfBirth="ngModel" [attr.aria-invalid]="(dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched || invalidForm))" autocomplete="bday">
                </div>
                <div *ngIf="!this.isVccs && dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched || invalidForm)">
                  <p class="error-message" *ngIf="dateOfBirth.errors?.minAgeDob"><i class="fa fa-times" aria-hidden="true"></i> You must be at least 7 years old to create an account. </p>
                  <p class="error-message" *ngIf="dateOfBirth.errors?.coppaDob">
                    <i class="fa fa-times" aria-hidden="true"></i> Due to laws regarding children's online privacy, this system will not accept accounts made by persons under the age of 13. For more information, please refer to the
                    <a href="/home/privacy.aspx" target="_blank">privacy statement.</a>
                  </p>
                  <p *ngIf="dateOfBirth.errors?.validDob" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Enter a valid birthdate in the following format 'mm/dd/yyyy'</p>

                </div>
                <div *ngIf="this.isVccs && dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched || invalidForm)">
                  <p class="error-message" *ngIf="dateOfBirth.errors?.coppaDob">
                    <i class="fa fa-times" aria-hidden="true"></i> Due to laws regarding children's online privacy, this system will not accept accounts made by persons under the age of 13. For more information, please refer to the
                    <a href="/home/privacy.aspx" target="_blank">privacy statement.</a>
                  </p>
                  <p *ngIf="dateOfBirth.errors?.validDob" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Enter a valid birthdate in the following format 'mm/dd/yyyy'</p>

                </div>
                <!--<div *ngIf="dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched || invalidForm)">
                  <p class="error-message" *ngIf="dateOfBirth.errors?.minAgeDob"><i class="fa fa-times" aria-hidden="true"></i> You must be at least 7 years old to create an account. </p>
                  <p class="error-message" *ngIf="dateOfBirth.errors?.coppaDob"><i class="fa fa-times" aria-hidden="true"></i>  Due to laws regarding children's online privacy, this system will not accept accounts made by persons under the age of 13. For more information, please refer to the <a href="/home/privacy.aspx" target="_blank">privacy statement.</a></p>
                  <p *ngIf="dateOfBirth.errors?.validDob" class="error-message"><i class="fa fa-times" aria-hidden="true"></i>  Enter a valid birthdate in the following format 'mm/dd/yyyy'</p>

                </div>-->

                <div *ngIf="isCoppaRestricted">
                  <p> Due to laws regarding children's online privacy, this system will not accept personal identifying information from persons under the age of 13. For more information, please refer to the <a href="/Home/privacy.aspx">privacy statement.</a></p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="question-section-divider marginT20 marginB20"></div>
            <div class="flex-container wrap">
              <div [hidden]="!config.SelectSchool?.Visible" [ngClass]="{'has-error': (schoolChoice?.invalid && (schoolChoice?.dirty || schoolChoice?.touched || invalidForm))}" class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div style="width:334px !important; font-size:inherit !important;">
                  <label for="Institution" class="control-label">{{(selectedRoleValue == 'p')? "Your child's school or organization" : "Your school, workforce center, or program"}}</label>
                  <div class="input-tooltip">
                    <ng-select-ext [ngModel]="schoolPickerHelper.rawValue" simpleInputId="school-select-input" comboInputId="school-combo-input" id="selectedSchoolRaw" name="selectedSchoolRaw" [multiple]="false" placeholder="{{(selectedRoleValue == 'p')? 'Enter your child\'s school or organization' : 'Enter your school, workforce center, or program'}}"
                                   [disabled]="!selectedRoleValue || selectedRoleValue == '-1'" (ngModelChange)="schoolPickerHelper.onDataUpdate($event); updateSchool($event); " class="multiSelectInput" (typed)="schoolPickerHelper.onTyped($event);"
                                   #selectedSchoolRaw></ng-select-ext>
                    <input type="hidden" [(ngModel)]="schoolPickerHelper.cleanValue" id="schoolChoice" name="schoolChoice" class="form-control" [isRequired]="config.SelectSchool?.Visible" [dynamicRequired]="f.controls['schoolChoice']" #schoolChoice="ngModel">
                    <div *ngIf="config.SchoolNotInList?.Visible  ">
                      <button type="button" class="btn btn-link btn-block btn-sm" a href="#" id="SchoolNotInList" (click)="schoolNotInList(schoolPickerHelper); $event.preventDefault()">My school/program is not on the list</button>
                    </div>
                  </div>
                  <div *ngIf="!isValidLicence" class="error-message">
                    <p><i class="fa fa-times" aria-hidden="true"></i> No current subscription. Please see your counselor or administrator</p>
                  </div>
                </div>
              </div>
              <div *ngIf="config.GradYear?.Visible && (config.GradYear?.Roles.indexOf(selectedRoleValue) !== -1)" [ngClass]="{'has-error': (gradYear.invalid && (gradYear.dirty || gradYear.touched || invalidForm))}">
                <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <label for="GradYear" class="control-label">{{(selectedRoleValue == 'hs' || selectedRoleValue== 'ms')? "Year of high school graduation" : "Expected year of college graduation"}}</label>
                  <div class="input-tooltip">
                    <select id="GradYear" [(ngModel)]="gradYearValue" name="gradYear" placeholder="Select one &hellip;" class="form-control" [dynamicRequired]="f.controls['gradYear']" [isRequired]="true" [ignoreDefaultValue]="-1" #gradYear="ngModel" [attr.aria-invalid]="(gradYear.invalid && (gradYear.dirty || gradYear.touched || invalidForm))">
                      <option value="-1">Select the year</option>
                      <option *ngFor="let i of gradYearRange">{{getGradeYearByGradYear(getDDDateYear() + i)}}</option>
                    </select>
                    <div *ngIf="gradYear.invalid && (gradYear.dirty || gradYear.touched || invalidForm)">
                      <p class="error-message" *ngIf="gradYear.errors?.dynamicRequired"><i class="fa fa-times" aria-hidden="true"></i> Please select your year of graduation.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default" *ngIf="(config.Email?.Visible || config.Cellphone?.Visible || config.EmailValidate?.Visible) && !isCoppaRestricted">
        <div class="panel-heading">
          <h3>Contact Information</h3>
          <hr />
        </div>
        <div class="panel-body">
          <div class="flex-container wrap" *ngIf="config.Cellphone?.Visible && (config.Cellphone?.Roles.indexOf(selectedRoleValue) !== -1)">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="Cellphone" class="control-label">Cell phone <span class="help">{{(config.Cellphone?.Required)? "" : "(optional)"}}</span></label>
              <div class="input-group">
                <span class="input-group-addon" id="addon-cell">
                  <i class="la la-phone"></i>
                </span>
                <div class="input-tooltip">
                  <input type="tel" [textMask]="{mask: phoneMask}" id="Cellphone" [(ngModel)]="cellphone" name="cellphone" class="form-control" placeholder="(###) ###-####" (ngModelChange)="checkCellPhoneValidity($event)" autocomplete="phone-cell">
                </div>
              </div>
            </div>
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" id="mobile-opt-in">
              <div *ngIf="config.Cellphone?.Visible && (config.Cellphone?.Roles.indexOf(selectedRoleValue) !== -1) && config.MobileOptIn?.Visible && (config.MobileOptIn?.Roles.indexOf(selectedRoleValue) !== -1)">
                <div class="opt-in">
                  <span class="control-label"><strong><u>Mobile opt in</u></strong></span>
                  <p>
                    Turn on text messaging to receive text messages from your school. Standard message rates could apply.
                  </p>
                  <p class="error-message" *ngIf="displayValidationError">You entered an incorrect validation code. Please try again.</p>
                  <div class="row">
                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4" style="display:inline-block;">
                      <label class="switch" for="MobileOptIn">
                        <span class="sr-only" aria-hidden="false">Mobile opt in</span>
                        <input type="checkbox" [(ngModel)]="mobileOptInCheckbox" id="MobileOptIn" name="mobileOptInCheckbox" class="form-control" (click)="toggleVerification()" [disabled]="!isCellPhoneValid">
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8" style="padding-left:0px;">
                      <p class="input-tooltip">
                        <button type="button" class="btn btn-danger btn-sm" *ngIf="!this.cellPhoneValidated && !this.displayValidationTextbox" [disabled]="!this.mobileOptInCheckbox" (click)="sendValidationCode(cellphone)"><i class="fa fa-exclamation" aria-hidden="true"></i> Validate Cell Phone Number</button>
                      <p class="validate-message" *ngIf="!this.cellPhoneValidated && this.displayValidationTextbox"><label for="userValidationCode">A validation code has been sent to <strong>{{cellphone}}</strong>. Please enter the 4 digit code to continue.</label></p>
                      <input type="text" class="form-control" maxlength="4" [(ngModel)]="userValidationCode" name="userValidationCode" id="userValidationCode" *ngIf="!this.cellPhoneValidated && this.displayValidationTextbox" autocomplete="phone-cell" />
                      <div class="verify-buttons">
                        <button type="button" class="btn btn-success btn-small white" *ngIf="!this.cellPhoneValidated && this.displayValidationTextbox" (click)="checkValidationCode(userValidationCode)">Click to verify</button>
                        <button type="button" class="btn btn-metal btn-small white" *ngIf="!this.cellPhoneValidated && this.displayValidationTextbox" (click)="cancelValidation()">Cancel</button>
                      </div>
                    </div>
                    <div class="alert alert-success" *ngIf="this.cellPhoneValidated">
                      <p>
                        <strong>
                          <i class="fa fa-check fa-2x"></i>
                          Phone number has been validated
                        </strong>
                      </p>
                    </div>
                    <div class="alert has-error" *ngIf="f.form.errors?.CellphoneNotValidated">
                      <p>
                        <strong>
                          <i class="fa fa-times"></i>
                          Phone number needs to be validated
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="question-section-divider" *ngIf="config.Cellphone?.Visible && (config.Cellphone?.Roles.indexOf(selectedRoleValue) !== -1) && config.MobileOptIn?.Visible && (config.MobileOptIn?.Roles.indexOf(selectedRoleValue) !== -1)"></div>
          <div class="flex-container wrap">
            <div *ngIf="config.EmailValidate?.Visible && !UseXapEmail" [ngClass]="{'has-error': (email?.invalid && (email?.dirty || email?.touched || invalidForm))}" class="form-group">
              <!-- [ngClass]="{'has-error': (validation.isEmailInvalid || validation.isEmailNotValidated) || ((!emailValidationCharacters || emailValidationExists)&& email)}"> -->
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="Email" class="control-label">Email address</label>
                <div class="input-group">
                  <span class="input-group-addon" id="addon-email">
                    <i class="la la-envelope"></i>
                  </span>
                  <div class="input-tooltip">
                    <input [readOnly]="this.invited" type="text" id="Email" class="form-control" name="Email" [(ngModel)]="emailValue" required #email="ngModel" autocomplete="email">
                    <input type="hidden" value="" id="EmailCo" class="form-control" name="EmailCo" [(ngModel)]="emailConfirmation" />
                    <input type="hidden" value="{{selectedResourceId}}" id="SchoolId" class="form-control" name="SchoolId" />
                  </div>
                  <button type="button" class="btn btn-danger inline" id="btnEmailValidate" onclick="return false"><i class="fa fa-exclamation" aria-hidden="true"></i> Validate Email Address</button>
                </div>
                <div class="email-error" *ngIf="email.errors?.EmailNotValidated">
                  <p><i class="fa fa-times" aria-hidden="true"></i> Please validate your email address.</p>
                </div>
                <div class="email-error" *ngIf="email.errors?.emailExists">
                  <p class="error-message"><i class="fa fa-times" aria-hidden="true"></i> An account with that email already exists. <a href="{{(AccountRecoveryURL)?AccountRecoveryURL : '/Home/Sign_In/Sign_In_Help.aspx' }}" target="_blank">Recover your account.</a></p>
                </div>
              </div>
            </div>
            <div *ngIf="config.Email?.Visible && UseXapEmail">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="email" class="control-label">Email address</label>
                <div class="input-group">
                  <span class="input-group-addon" id="addon-email">
                    <i class="la la-envelope"></i>
                  </span>
                  <div class="input-tooltip">
                    <div class="email form-control">
                      <strong>{{accountNameValue}}@{{domain}}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="config.Email?.Visible && !UseXapEmail" [ngClass]="{'has-error': (email.invalid && (email.dirty || email.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="Email" class="control-label">Email address</label>
                <div class="input-group">
                  <span class="input-group-addon" id="addon-email">
                    <i class="la la-envelope"></i>
                  </span>
                  <div class="input-tooltip">
                    <input [readOnly]="this.invited" type="text" id="Email" [emailSuggestion]="f.controls['Email']" [doesEmailExist]="f.controls['Email']" class="form-control" name="Email" [(ngModel)]="emailValue" [confirmValue]="f.controls['Email']" [confirmAgainst]="f.controls['EmailConfirmation']"
                           [reverse]="true" [dynamicRequired]="f.controls['Email']" [isRequired]="true" [regexPattern]="f.controls['Email']" patternType="email" #email="ngModel" [attr.aria-invalid]="(email.invalid && (email.dirty || email.touched || invalidForm))"
                           autocomplete="email">
                  </div>
                </div>
                <div *ngIf="f.controls['Email'] && f.controls['Email'].warnings">
                  Did you mean <b><i> <a (click)="updateEmail(f.controls['Email'])">{{f.controls['Email'].warnings}}</a></i></b>?
                </div>
                <div *ngIf="email.invalid && (email.dirty || email.touched || invalidForm)">
                  <p *ngIf="email.errors?.regexPattern || email.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Ensure your email address is valid and does not contain ' or ".</p>
                  <p *ngIf="email.errors?.emailExists" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> An account with that email already exists. <a href="{{(AccountRecoveryURL)?AccountRecoveryURL : '/Home/Sign_In/Sign_In_Help.aspx' }}" target="_blank">Recover your account.</a></p>
                </div>
              </div>
            </div>
            <div *ngIf="config.EmailConfirmation?.Visible && config.Email?.Visible &&  !UseXapEmail" [ngClass]="{'has-error': (emailConfirmation.invalid && (emailConfirmation.dirty || emailConfirmation.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="EmailConfirmation" class="control-label">Confirm email address</label>
                <div class="input-group">
                  <span class="input-group-addon" id="addon-confirm-email">
                    <i class="la la-envelope"></i>
                  </span>
                  <div class="input-tooltip">
                    <input [readOnly]="this.invited" type="text" id="EmailConfirmation" class="form-control" name="EmailConfirmation" [(ngModel)]="emailConfirmationValue" [confirmValue]="f.controls['EmailConfirmation']" [confirmAgainst]="f.controls['Email']" [dynamicRequired]="f.controls['EmailConfirmation']"
                           [isRequired]="true" #emailConfirmation="ngModel" [attr.aria-invalid]="(emailConfirmation.invalid && (emailConfirmation.dirty || emailConfirmation.touched || invalidForm))">
                  </div>
                </div>
                <div *ngIf="emailConfirmation.invalid && (emailConfirmation.dirty || emailConfirmation.touched || invalidForm)">
                  <p *ngIf="emailConfirmation.errors?.dynamicRequired || emailConfirmation.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Your email confirmation must match your email.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="config.UseXapEmail?.Visible && !this.invited">
            <fieldset>
              <legend class="sr-only" aria-hidden="false">Use Xap Email</legend>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 checkbox-style" style="padding:10px 34px 0px;">
                <!--<label for="UseXapEmail" class="control-label">Use Xap Email Address</label>-->
                <div class="input-tooltip">
                  <input type="checkbox" id="UseXapEmail" name="UseXapEmail" [(ngModel)]="UseXapEmail">
                  <label for="UseXapEmail">
                    {{config.UseXapEmail?.Text}}
                  </label>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>


      <div class="panel panel-default" [hidden]="!config.AddressPanel?.Visible || isCoppaRestricted" *ngIf="!isCoppaRestricted">
        <div class="panel-heading">
          <h3>Permanent Address</h3>
          <hr />
        </div>
        <div class="panel-body">
          <div class="flex-container wrap">
            <div *ngIf="config.Street?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (address.invalid && (address.dirty || address.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="Address" class="control-label">Address <span class="help">{{(config.Street?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <input type="text" id="Address" [isRequired]="config.Street?.Required" [dynamicRequired]="f.controls['address']" [(ngModel)]="addressValue" name="address" class="form-control" #address="ngModel" autocomplete="permanent address-line1">
                </div>
                <div *ngIf="address.invalid && (address.dirty || address.touched || invalidForm)">
                  <p *ngIf="address.errors?.dynamicRequired || address.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter street.</p>
                </div>
              </div>
            </div>
            <div *ngIf="config.City?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (city.invalid && (city.dirty || city.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="City" class="control-label">City <span class="help">{{(config.City?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <input type="text" id="City" [(ngModel)]="cityValue" [isRequired]="config.City?.Required" [dynamicRequired]="f.controls['city']" name="city" class="form-control" #city="ngModel" autocomplete="permanent address-city">
                </div>
                <div *ngIf="city.invalid && (city.dirty || city.touched || invalidForm)">
                  <p *ngIf="city.errors?.dynamicRequired || city.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter city.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-container wrap">
            <div [hidden]="!config.State?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (stateChoice.invalid && (stateChoice.dirty || stateChoice.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div style="width:334px !important; font-size:inherit !important;">
                  <label for="State" class="control-label">U.S. state/territory <span class="help">{{(config.State?.Required)? "" : "(optional)"}}</span></label>
                  <div class="input-tooltip">
                    <ng-select-ext [ngModel]="statePickerHelper.rawValue" simpleInputId="state-select-input" comboInputId="state-combo-input" id="stateChoiceRaw" name="stateChoiceRaw" [multiple]="false" placeholder="Select your state" (ngModelChange)="statePickerHelper.onDataUpdate($event)"
                                   class="multiSelectInput" (typed)="statePickerHelper.onTyped($event)" #selectedStateRaw autocomplete="permanent address-state"></ng-select-ext>
                    <input type="hidden" [(ngModel)]="statePickerHelper.cleanValue" id="stateChoice" [isRequired]="config.State?.Required" [dynamicRequired]="f.controls['stateChoice']" name="stateChoice" #stateChoice="ngModel">
                  </div>
                </div>
                <div *ngIf="stateChoice.invalid && (stateChoice.dirty || stateChoice.touched || invalidForm)">
                  <p *ngIf="stateChoice.errors?.dynamicRequired || stateChoice.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter U.S. state/territory</p>
                </div>
              </div>
            </div>
            <div *ngIf="config.Zipcode?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (zip.invalid && (zip.dirty || zip.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="Zip" class="control-label">Zip code <span class="help">{{(config.Zipcode?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <input type="tel" id="Zip" [(ngModel)]="zipValue" [isRequired]="config.Zipcode?.Required" [dynamicRequired]="f.controls['zip']" name="zip" class="form-control" #zip="ngModel" autocomplete="permanent address-zipcode">
                </div>
                <div *ngIf="zip.invalid && (zip.dirty || zip.touched || invalidForm)">
                  <p *ngIf="zip.errors?.dynamicRequired || zip.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter zip code.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-container wrap">
            <div *ngIf="config.County?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (county.invalid && (county.dirty || county.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div style="width:334px !important; font-size:inherit !important;">
                  <label for="County" class="control-label">County <span class="help">{{(config.County?.Required)? "" : "(optional)"}}</span></label>
                  <div class="input-tooltip">
                    <input type="text" id="County" [(ngModel)]="countyValue" [isRequired]="config.County?.Required" [dynamicRequired]="f.controls['county']" name="county" class="form-control" #county="ngModel" autocomplete="permanent address-county">
                  </div>
                </div>
                <div *ngIf="county.invalid && (county.dirty || county.touched || invalidForm)">
                  <p *ngIf="county.errors?.dynamicRequired || county.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter county.</p>
                </div>
              </div>
            </div>
            <div [hidden]="!config.Country?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (countryChoice.invalid && (countryChoice.dirty || countryChoice.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div style="width:334px !important; font-size:inherit !important;">
                  <label for="Country" class="control-label">Country <span class="help">{{(config.Country?.Required)? "" : "(optional)"}}</span></label>
                  <div class="input-tooltip">
                    <ng-select-ext [ngModel]="countryPickerHelper.rawValue" simpleInputId="country-select-input" comboInputId="country-combo-input" id="countryChoiceRaw" name="countryChoiceRaw" [multiple]="false" placeholder="Select your country" (ngModelChange)="countryPickerHelper.onDataUpdate($event)"
                                   class="multiSelectInput" (typed)="countryPickerHelper.onTyped($event)" #selectedCountryRaw autocomplete="permanent address-country"></ng-select-ext>
                    <input type="hidden" [(ngModel)]="countryPickerHelper.cleanValue" id="countryChoice" [isRequired]="config.Country?.Required" [dynamicRequired]="f.controls['countryChoice']" name="countryChoice" #countryChoice="ngModel">
                  </div>
                </div>
                <div *ngIf="countryChoice.invalid && (countryChoice.dirty || countryChoice.touched || invalidForm)">
                  <p *ngIf="countryChoice.errors?.dynamicRequired || countryChoice.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter country.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-container wrap">
            <div *ngIf="config.InternationalPostalCode?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (internationalPostalCode.invalid && (internationalPostalCode.dirty || internationalPostalCode.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="InternationalPostalCode" class="control-label">International postal code <span class="help">{{(config.InternationalPostalCode?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <input type="text" id="InternationalPostalCode" [(ngModel)]="internationalPostalCodeValue" name="internationalPostalCode" class="form-control" [isRequired]="config.InternationalPostalCode?.Required" [dynamicRequired]="f.controls['internationalPostalCode']"
                         #internationalPostalCode="ngModel" autocomplete="permanent address-postalcode">
                </div>
                <div *ngIf="internationalPostalCode.invalid && (internationalPostalCode.dirty || internationalPostalCode.touched || invalidForm)">
                  <p *ngIf="internationalPostalCode.errors?.dynamicRequired || internationalPostalCode.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter international postal code.</p>
                </div>
              </div>
            </div>
            <div *ngIf="config.DayPhone?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (dayPhone.invalid && (dayPhone.dirty || dayPhone.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="DayPhone" class="control-label">Daytime telephone <span class="help">{{(config.DayPhone?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <input type="tel" [textMask]="{mask: phoneMask}" id="DayPhone" [(ngModel)]="dayPhoneValue" [isRequired]="config.DayPhone?.Required" [dynamicRequired]="f.controls['dayPhone']" name="dayPhone" class="form-control" placeholder="(###) ###-####" #dayPhone="ngModel"
                         autocomplete="phone-daytime">
                </div>
                <div *ngIf="dayPhone.invalid && (dayPhone.dirty || dayPhone.touched || invalidForm)">
                  <p *ngIf="dayPhone.errors?.dynamicRequired || dayPhone.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter daytime telephone.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-container wrap">
            <div *ngIf="config.EveningPhone?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (eveningPhone.invalid && (eveningPhone.dirty || eveningPhone.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="EveningPhone" class="control-label">Evening telephone <span class="help">{{(config.EveningPhone?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <input [textMask]="{mask: phoneMask}" type="tel" id="EveningPhone" [(ngModel)]="eveningPhoneValue" [isRequired]="config.EveningPhone?.Required" [dynamicRequired]="f.controls['eveningPhone']" name="eveningPhone" class="form-control" placeholder="(###) ###-####"
                         #eveningPhone="ngModel" autocomplete="phone-evening">
                </div>
                <div *ngIf="eveningPhone.invalid && (eveningPhone.dirty || eveningPhone.touched || invalidForm)">
                  <p *ngIf="eveningPhone.errors?.dynamicRequired || eveningPhone.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter evening telephone.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="panel panel-default" [hidden]="!config.MailingAddressPanel?.Visible || isCoppaRestricted">
        <div class="panel-heading">
          <h3>Mailing Address</h3>
          <hr />
        </div>
        <div class="flex-container wrap">
          <div class="form-group" *ngIf="config.MailingStreet?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="MailingAddress" class="control-label">Address</label>
              <div class="input-tooltip">
                <input type="text" id="MailingAddress" [isRequired]="true" [dynamicRequired]="f.controls['mailingaddress']" [(ngModel)]="mailingaddressValue" name="mailingaddress" class="form-control" #mailingaddress="ngModel" autocomplete="mailing address-line1">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.MailingCity?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="MailingCity" class="control-label">City</label>
              <div class="input-tooltip">
                <input type="text" id="MailingCity" [(ngModel)]="mailingcity" name="mailingcity" class="form-control" autocomplete="mailing address-city">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.MailingState?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="mailingStateChoice" class="control-label">U.S. state/territory</label>
              <div class="input-tooltip">
                <ng-select-ext [ngModel]="mailingStatePickerHelper.rawValue" simpleInputId="state-select-input" comboInputId="state-combo-input" name="mailingStateChoiceRaw" [multiple]="false" placeholder="Select your state" (ngModelChange)="mailingStatePickerHelper.onDataUpdate($event)"
                               class="multiSelectInput" (typed)="mailingStatePickerHelper.onTyped($event)" #mailingSelectedStateRaw autocomplete="mailing address-state"></ng-select-ext>
                <input type="hidden" [(ngModel)]="mailingStatePickerHelper.cleanValue" id="mailingStateChoice" name="mailingStateChoice" #mailingStateChoice="ngModel">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.MailingZipcode?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="MailingZip" class="control-label">Zip code</label>
              <div class="input-tooltip">
                <input type="tel" id="MailingZip" [(ngModel)]="mailingzip" name="mailingzip" class="form-control" autocomplete="mailing address-zipcode">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.MailingCounty?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="MailingCounty" class="control-label">County</label>
              <div class="input-tooltip">
                <input type="text" id="MailingCounty" [(ngModel)]="mailingcounty" name="mailingcounty" class="form-control" autocomplete="mailingaddress-county">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.MailingCountry?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="mailingCountryChoice" class="control-label">Country</label>
              <div class="input-tooltip">
                <ng-select-ext [ngModel]="mailingCountryPickerHelper.rawValue" simpleInputId="country-select-input" comboInputId="country-combo-input" name="mailingCountryChoiceRaw" [multiple]="false" placeholder="Select your country" (ngModelChange)="mailingCountryPickerHelper.onDataUpdate($event)"
                               class="multiSelectInput" (typed)="mailingCountryPickerHelper.onTyped($event)" #mailingSelectedCountryRaw autocomplete="mailing address-country"></ng-select-ext>
                <input type="hidden" [(ngModel)]="mailingCountryPickerHelper.cleanValue" id="mailingCountryChoice" name="mailingCountryChoice" #mailingCountryChoice="ngModel">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.MailingInternationalPostalCode?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="MailingInternationalPostalCode" class="control-label">International postal code</label>
              <div class="input-tooltip">
                <input type="text" id="mailingInternationalPostalCode" [(ngModel)]="mailinginternationalPostalCode" name="mailinginternationalPostalCode" class="form-control" autocomplete="mailing address-postalcode">
              </div>
            </div>
          </div>
          <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <!--<label for="UseXapEmail" class="control-label">Use Xap Email Address</label>-->
            <div class="input-tooltip">
              <input type="checkbox" id="usePermForMailing" name="usePermForMailing" (change)="PermAddressForMailingChecked($event)">
            </div>
            <div>
              <label for="usePermForMailing" class="control-label">
                Check here if your mailing address is the same as your permanent address.
              </label>
            </div>
          </div>
        </div>
      </div>


      <div class="panel panel-default" *ngIf="config.AccountName?.Visible || config.Password?.Visible">
        <div class="panel-heading">
          <h3>Username and Password</h3>
          <hr />
        </div>
        <div class="panel-body">
          <div class="flex-container wrap" *ngIf="config.AccountName?.Visible" [ngClass]="{'has-error': (accountName.invalid && (accountName.dirty || accountName.touched || invalidForm))}">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="AccountName" class="control-label">Username</label>
              <div class="input-group">
                <span class="input-group-addon" id="username-addon">
                  <i class="la la-user"></i>
                </span>
                <div class="input-tooltip">
                  <input type="text" id="AccountName" name="accountName" class="form-control" maxlength="60" [doesAccountNameExist]="f.controls['accountName']" [(ngModel)]="accountNameValue" [disallowedWords]="f.controls['accountName']" [minimumLength]="f.controls['accountName']"
                         length="5" [confirmValue]="f.controls['accountName']" [confirmAgainst]="f.controls['password']" [notEquals]="true" [reverse]="true" #accountName="ngModel" [dynamicRequired]="f.controls['accountName']" [isRequired]="true"
                         [regexPattern]="f.controls['accountName']" patternType="username" [attr.aria-invalid]="(accountName.invalid && (accountName.dirty || accountName.touched || invalidForm))" autocomplete="username">
                </div>
              </div>
              <div *ngIf="accountName.invalid && (accountName.dirty || accountName.touched || invalidForm)">
                <p *ngIf="accountName.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter your username.</p>
                <p *ngIf="accountName.errors?.minimumLength || accountName.errors?.regexPattern" class="error-message">
                  <i class="fa fa-times" aria-hidden="true"></i> Your username must be at least 5 letters long. Use only characters a-z, 0-9, (,), -, and _. Other characters, including " and ', are not allowed. Email addresses are allowed,
                  but cannot contain ' or ".
                </p>
                <p *ngIf="accountName.errors?.disallowedWords" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> The username you have selected is not allowed. Please choose another.</p>
                <p *ngIf="accountName.errors?.accountNameExists" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> An account with that username already exists. <a href="{{(AccountRecoveryURL)?AccountRecoveryURL : '/Home/Sign_In/Sign_In_Help.aspx' }}" target="_blank">Recover your account</a>                                    or try another username.</p>
                <p *ngIf="accountName.errors?.isSite" class="error-message">
                  <i class="fa fa-times" aria-hidden="true"></i> You have entered an email. This means you do not need this site to create an email address for you. Please uncheck the ‘use this site’s email account as your primary email
                  box’ to continue.
                </p>
                <!--<p *ngIf="accountName && (accountValidationMinLength && !accountValidationCharacters && !accountValidationWords && !accountValidationUsernameExists) && accountValidationMaxLength" class="error"><i class="fa fa-times" aria-hidden="true"></i>  Your username must be 60 characters or below long.</p>-->
                <!--<p *ngIf="accountName && accountValidationMinLength && !accountValidationCharacters && !accountValidationWords && !accountValidationUsernameExists && !accountValidationMaxLength"><i class="fa fa-check" aria-hidden="true"></i> Ok</p>-->
              </div>
            </div>
          </div>
          <div class="flex-container wrap" *ngIf="config.Password?.Visible" [ngClass]="{'has-error': (password.invalid && (password.dirty || password.touched || invalidForm))}">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-10" *ngIf="config.Password?.Text == 'complexpassword'">
              Please create a new password following these requirements:
              <ul class="mb-0">
                <li>8-12 characters</li>
                <li>No spaces or special characters</li>
                <li>Contains at least one number</li>
                <li>It cannot match your username</li>
              </ul>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-10" *ngIf="config.Password?.Text == 'simplepassword'">
              Please create a new password following these requirements:
              <ul class="mb-0">
                <li>5-12 characters</li>
                <li>No spaces or special characters</li>
                <li>It cannot match your username</li>
              </ul>
            </div>
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="Password" class="control-label">Password</label>
              <div class="input-group">
                <span class="input-group-addon" id="addon-password">
                  <i class="la la-lock"></i>
                </span>
                <div class="input-tooltip">
                  <input type="password" id="Password" name="password" class="form-control" [maxlength]="12" [confirmValue]="f.controls['password']" [confirmAgainst]="f.controls['accountName']" [notEquals]="true" [alsoReverseConfirm]="f.controls['passwordConfirmation']"
                         [(ngModel)]="passwordValue" #password="ngModel" [dynamicRequired]="f.controls['password']" [isRequired]="true" [regexPattern]="f.controls['password']" [patternType]="config.Password?.Text" [attr.aria-invalid]="(password.invalid && (password.dirty || password.touched || invalidForm))"
                         autocomplete="new-password">
                </div>
              </div>
              <div *ngIf="password.invalid && (password.dirty || password.touched || invalidForm)">
                <p *ngIf="password.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter a password.</p>
                <p *ngIf="password.errors?.regexPattern && config.Password?.Text == 'complexpassword'" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Your password must be 8-12 letters long, with no spaces or special characters, and contain at least one number.</p>
                <p *ngIf="password.errors?.regexPattern && config.Password?.Text == 'simplepassword'" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Your password must be 5-12 letters long, with no spaces or special characters.</p>
                <p *ngIf="password.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Your password cannot match your username.</p>
                <!--<p *ngIf="password && !passwordValidationCharacters && (password != accountName)"><i class="fa fa-check" aria-hidden="true"></i> Ok</p>-->
              </div>
            </div>
            <div *ngIf="config.PasswordConfirmation?.Visible" [ngClass]="{'has-error': (passwordConfirmation.invalid && (passwordConfirmation.dirty || passwordConfirmation.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="PasswordConfirmation" class="control-label">Confirm password</label>
                <div class="input-group">
                  <span class="input-group-addon" id="addon-confirm-password">
                    <i class="la la-lock"></i>
                  </span>
                  <div class="input-tooltip">
                    <input type="password" id="PasswordConfirmation" class="form-control" [maxlength]="12" name="passwordConfirmation" [(ngModel)]="passwordConfirmationValue" [dynamicRequired]="f.controls['passwordConfirmation']" [isRequired]="true" #passwordConfirmation="ngModel"
                           [confirmValue]="f.controls['passwordConfirmation']" [confirmAgainst]="f.controls['password']" [attr.aria-invalid]="(passwordConfirmation.invalid && (passwordConfirmation.dirty || passwordConfirmation.touched || invalidForm))"
                           autocomplete="new-password">
                  </div>
                </div>
                <div *ngIf="passwordConfirmation.invalid && (passwordConfirmation.dirty || passwordConfirmation.touched || invalidForm)">
                  <p *ngIf="passwordConfirmation.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please enter a password confirmation.</p>
                  <p *ngIf="passwordConfirmation.errors?.confirmation" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Your password confirmation must match your password.</p>
                  <!--<p *ngIf="passwordConfirmation && ( passwordConfirmation == password)"><i class="fa fa-check" aria-hidden="true"></i>   Ok.</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="panel panel-default" *ngIf="config.SecurityQuestion?.Visible && config.SecurityAnswer?.Visible">
        <div class="panel-heading">
          <h3>Account Security</h3>
          <hr />
        </div>
        <p>Please select a security question and enter your answer. If you forget your username or password in the future, the answer to this security question can be used to retrieve your account information.</p>
        <div class="panel-body">
          <div class="flex-container wrap" [ngClass]="{'has-error': (securityQuestion.invalid && (securityQuestion.dirty || securityQuestion.touched || invalidForm))}" *ngIf="config.SecurityQuestion?.Visible">
            <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label for="securityQuestion" class="control-label">Question</label>
              <div class="input-tooltip">
                <select id="securityQuestion" name="securityQuestion" [(ngModel)]="securityQuestionValue" placeholder="Select a Question" class="form-control" [dynamicRequired]="f.controls['securityQuestion']" [isRequired]="true" [ignoreDefaultValue]="-1" #securityQuestion="ngModel"
                        [attr.aria-invalid]="(securityQuestion.invalid && (securityQuestion.dirty || securityQuestion.touched || invalidForm))">
                  <option value="-1" disabled selected="selected">Select a question</option>
                  <option value="What is your grandmother's first name?">What is your grandmother's first name?</option>
                  <option value="What is the last name of your favorite teacher or mentor?">What is the last name of your favorite teacher or mentor?</option>
                  <option value="What is the first name of your favorite aunt?">What is the first name of your favorite aunt?</option>
                  <option value="What is the first name of your favorite uncle?">What is the first name of your favorite uncle?</option>
                  <option value="In what city were you born?">In what city were you born?</option>
                  <option value="What is the middle name of your youngest sibling?">What is the middle name of your youngest sibling?</option>
                  <option value="What is the middle name of your oldest sibling?">What is the middle name of your oldest sibling?</option>
                  <option value="What is your mother's middle name?">What is your mother's middle name?</option>
                  <option value="What is your father's middle name?">What is your father's middle name?</option>
                  <option value="What is your mother's maiden name?">What is your mother's maiden name?</option>
                  <option value="What is the first name of your favorite childhood friend?">What is the first name of your favorite childhood friend?</option>
                </select>
              </div>
              <div *ngIf="securityQuestion.invalid && (securityQuestion.dirty || securityQuestion.touched || invalidForm)">
                <p *ngIf="securityQuestion.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please select a security question.</p>
              </div>
            </div>
            <div [ngClass]="{'has-error': (securityAnswer.invalid && (securityAnswer.dirty || securityAnswer.touched || invalidForm))}" *ngIf="config.SecurityAnswer?.Visible">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="SecurityAnswer" class="control-label">Answer</label>
                <div class="input-tooltip">
                  <input type="text" id="SecurityAnswer" [(ngModel)]="securityAnswerValue" name="securityAnswer" class="form-control" [dynamicRequired]="f.controls['securityAnswer']" [isRequired]="true" #securityAnswer="ngModel" [attr.aria-invalid]="(securityAnswer.invalid && (securityAnswer.dirty || securityAnswer.touched || invalidForm))">
                </div>
                <div *ngIf="securityAnswer.invalid && (securityAnswer.dirty || securityAnswer.touched || invalidForm)">
                  <p *ngIf="securityAnswer.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please select a security answer.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="panel panel-default" *ngIf="config.AdditionalInformationPanel?.Visible && !isCoppaRestricted">
        <div class="panel-heading">
          <h3>Additional Information</h3>
          <hr />
        </div>
        <div class="panel-body">
          <div class="form-group" *ngIf="config.PersonalInfoSharing?.Visible">
            <fieldset>
              <legend class="sr-only" aria-hidden="false">Data Sharing</legend>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 checkbox-style" style="padding-left:50px;">
                <div class="input-tooltip">
                  <input type="checkbox" id="personalInfoSharing" name="personalInfoSharing" [(ngModel)]="personalInfoSharing">
                  <label for="personalInfoSharing" [innerHTML]="config.PersonalInfoSharing?.Text">
                  </label>
                </div>
              </div>
            </fieldset>
            <div class="question-section-divider marginB10"></div>
          </div>
          <div class="form-group" *ngIf="config.Coppa?.Visible">
            <fieldset>
              <legend class="sr-only" aria-hidden="false">COPPA</legend>
              <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-4">
                <div class="checkbox-style">
                  <div class="input-tooltip">
                    <input type="checkbox" id="coppa" name="coppa" [(ngModel)]="coppa"><label for="coppa">COPPA</label>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="form-group" *ngIf="config.Ssn?.Visible">
            <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-4">
              <label for="ssn" class="control-label">Social security number</label>
              <div class="input-tooltip">
                <input type="tel" id="ssn" [(ngModel)]="ssn" name="ssn" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.Citizen?.Visible">
            <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-4">
              <label for="citizen" class="control-label">Citizen or permanent resident?</label>
              <div class="input-tooltip">
                <select id="citizen" name="citizen" placeholder="citizen" class="form-control" [(ngModel)]="citizen">
                  <option value="">Select citizen or permanent resident status.</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="config.Religion?.Visible">
            <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-4">
              <label for="religion" class="control-label">Religious affiliation</label>
              <div class="input-tooltip">
                <select id="religion" name="religion" placeholder="Religion" class="form-control" [(ngModel)]="religion">
                  <option value="" disabled [selected]="isSelected">Select a religious affiliation.</option>
                  <option value="1">African Methodist Episcopal</option>
                  <option value="2">Agnostic</option>
                  <option value="3">Angelican</option>
                  <option value="4">Apostolic Christian</option>
                  <option value="5">Assemblies of God</option>
                  <option value="6">Atheist</option>
                  <option value="7">Baha'I Faith</option>
                  <option value="8">Baptist</option>
                  <option value="9">Baptist (Conservative)</option>
                  <option value="10">Baptist (Other)</option>
                  <option value="11">Baptist (Southern)</option>
                  <option value="12">Buddhist</option>
                  <option value="13">Campus Crusade for Christ</option>
                  <option value="14">Catholic</option>
                  <option value="15">Catholic (Greek)</option>
                  <option value="16">Catholic (Other)</option>
                  <option value="17">Catholic (Roman)</option>
                  <option value="18">Christian</option>
                  <option value="19">Christian (Disciples of Christ)</option>
                  <option value="20">Christian (Other)</option>
                  <option value="21">Christian Brethren (Plymouth Brethren)</option>
                  <option value="22">Christian Reformed</option>
                  <option value="23">Christian Science</option>
                  <option value="24">Church of Christ</option>
                  <option value="25">Church of God</option>
                  <option value="26">Church of the Nazarene</option>
                  <option value="27">Congregational</option>
                  <option value="28">Coptic</option>
                  <option value="29">Eastern Christian Orthodox</option>
                  <option value="30">Episcopal</option>
                  <option value="31">Evangelist</option>
                  <option value="32">First Christian</option>
                  <option value="33">Grace Reformed</option>
                  <option value="34">Great Commission</option>
                  <option value="35">Hindu</option>
                  <option value="36">Interdenominational</option>
                  <option value="37">Intervarsity Christian Fellowship</option>
                  <option value="38">Jain</option>
                  <option value="39">Jehovah's Witnesses</option>
                  <option value="40">Jewish</option>
                  <option value="41">Jewish (Conservative)</option>
                  <option value="42">Jewish (Orthodox)</option>
                  <option value="43">Jewish (Other)</option>
                  <option value="44">Jewish (Reform)</option>
                  <option value="45">Latter-day Saint (Mormon)</option>
                  <option value="46">Lutheran (Missouri Synod)</option>
                  <option value="47">Lutheran (National Conference)</option>
                  <option value="48">Lutheran (Unspecified)</option>
                  <option value="49">Lutheran (Wisconsin)</option>
                  <option value="50">Mennonite</option>
                  <option value="51">Methodist</option>
                  <option value="52">Muslim</option>
                  <option value="53">Navigators</option>
                  <option value="54">Non-Christian (Other)</option>
                  <option value="55">None</option>
                  <option value="56">Other</option>
                  <option value="57">Pentecostal</option>
                  <option value="58">Presbyterian</option>
                  <option value="59">Presbyterian (Reformed)</option>
                  <option value="60">Protestant</option>
                  <option value="61">Protestant (Other)</option>
                  <option value="62">Reorganized Latter-day Saint</option>
                  <option value="63">Seventh-Day Adventist</option>
                  <option value="64">Sikh</option>
                  <option value="65">Society of Friends</option>
                  <option value="66">Trinity Church</option>
                  <option value="67">Unification</option>
                  <option value="68">Unified Family</option>
                  <option value="69">Unitarian Universalists</option>
                  <option value="70">United Church</option>
                  <option value="71">Wesleyan</option>
                  <option value="72">World Wide Discipleship</option>
                </select>
              </div>
            </div>
          </div>
          <div class="flex-container wrap">
            <div *ngIf="config.Sex?.Visible && !isCoppaRestricted" [ngClass]="{'has-error': (sex.invalid && (sex.dirty || sex.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="sex" class="control-label">Sex <span class="help">{{(config.Sex?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <select id="sex" name="sex" placeholder="Select your legally assigned sex." class="form-control" [(ngModel)]="sexValue" [dynamicRequired]="f.controls['sex']" [isRequired]="config.Sex?.Required" [ignoreDefaultValue]="-1" #sex="ngModel" autocomplete="sex">
                    <option value="-1">Select your legally assigned sex.</option>
                    <option value="m">Male</option>
                    <option value="f">Female</option>
                  </select>
                </div>
                <div *ngIf="sex.invalid && (sex.dirty || sex.touched || invalidForm)">
                  <p class="error-message" *ngIf="sex.errors?.dynamicRequired"><i class="fa fa-times" aria-hidden="true"></i> Please select your legally assigned sex.</p>
                </div>
              </div>
            </div>
            <div *ngIf="config.StudentStateId?.Visible">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="studentStateId" class="control-label">State-Assigned Student ID <span class="help">(optional)</span></label>
                <div class="input-tooltip">
                  <input type="text" id="studentStateId" [(ngModel)]="studentStateId" name="studentStateId" class="form-control">
                </div>
              </div>
            </div>
            <div *ngIf="config.Ethnicity?.Visible && !isCoppaRestricted">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="ethnicity" class="control-label">What is your ethnicity? <span class="help">{{(config.Ethnicity?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <select id="ethnicity" name="ethnicity" [(ngModel)]="ethnicity" placeholder="ethnicity" class="form-control" (change)="onEthnicityChange($event.target.value)">
                    <option value="-1" selected>Select your ethnicity</option>
                    <option value="hispanic">Hispanic or Latino</option>
                    <option value="nonHispanic">Not Hispanic or Latino</option>
                  </select>
                </div>
              </div>
            </div>

            <div *ngIf="ethnicity=='nonHispanic'">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 paddingT15 paddingB20">
                <fieldset>
                  <legend class="sr-only" aria-hidden="false">
                    What is your race?
                  </legend>
                  <div class="control-label" style="text-align:left;">
                    What is your race? <span class="help"> {{(config.Ethnicity?.Required)? "" : "(optional)"}}</span><br /> <em>Choose one or more races to indicate what you consider yourself to be.</em>
                  </div>
                  <div class="checkbox-style">
                    <div class="input-tooltip">
                      <input type="checkbox" id="native" name="native" [(ngModel)]="native" value="American Indian or Alaska Native" /><label for="native">American Indian or Alaska Native</label><br />
                      <input type="checkbox" id="asian" name="asian" [(ngModel)]="asian" value="Asian" /><label for="asian">Asian</label><br />
                      <input type="checkbox" id="africanAmerican" name="africanAmerican" [(ngModel)]="africanAmerican" value="Black or African American" /><label for="africanAmerican">Black or African American</label><br />
                      <input type="checkbox" id="hawaiian" name="hawaiian" [(ngModel)]="hawaiian" value="Native Hawaiian or Other Pacific Islander" /><label for="hawaiian">Native Hawaiian or Other Pacific Islander</label><br />
                      <input type="checkbox" id="white" name="white" [(ngModel)]="white" value="White" /><label for="white">White</label><br />
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div *ngIf="config.HowHear?.Visible" [ngClass]="{'has-error': (referredBy.invalid && (referredBy.dirty || referredBy.touched || invalidForm))}">
              <div class="flex-item col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label for="referredBy" class="control-label">How did you hear about this site? <span class="help">{{(config.HowHear?.Required)? "" : "(optional)"}}</span></label>
                <div class="input-tooltip">
                  <select id="referredBy" name="referredBy" placeholder="Select one &hellip;" class="form-control" [(ngModel)]="referredByModel" [dynamicRequired]="f.controls['referredBy']" [isRequired]="config.HowHear?.Required" #referredBy="ngModel" [ignoreDefaultValue]="-1"
                          [disabled]="howHearDisabled">
                    <option value="-1" disabled selected>Select one</option>
                    <option *ngFor="let i of config.HowHear?.Text" value="{{i.value}}">{{i.name}}</option>
                  </select>
                </div>
                <div *ngIf="referredBy.invalid && (referredBy.dirty || referredBy.touched || invalidForm)">
                  <p *ngIf="referredBy.errors?.dynamicRequired" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please tell us how you heard about this site.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default" *ngIf="config.ImportChoices?.Visible">
        <div class="panel-heading">
          <h3>Import from a Choices Portfolio to Your Account</h3>
          <hr />
        </div>
        <div class="panel-body">
          <div class="form-group">
            <div *ngIf="config.ImportChoices?.Visible">
              <fieldset>
                <legend class="sr-only" aria-hidden="false">Import Choices Portfolio</legend>
                <p class="paddingB20">If you have previously used Choices Explorer or Choices Planner you can import your Choices portfolio contents into your new account.</p>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 checkbox-style" style="padding-left:35px;">
                  <div class="input-tooltip">
                    <input type="checkbox" id="importChoices" name="importChoices" [(ngModel)]="importChoices">
                    <label for="importChoices">Import from my existing Choices portfolio</label>
                  </div>
                </div>
              </fieldset>
              <div>
                <p *ngIf="choicesUsernameError" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> There is no record for that choices portfolio name. Please confirm and try again.</p>
                <p *ngIf="choicesPasswordError" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Choices portfolio password does not match. Please confirm your password and try again. Passwords are case-sensitive.</p>
              </div>
              <div class="form-group paddingT20" *ngIf="importChoices">
                <div class="col-xs-12 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3 col-xl-6 col-xl-offset-3">
                  <label for="ChoicesUserName" class="control-label">Portfolio Name</label>
                  <div class="input-tooltip">
                    <input type="text" id="ChoicesUserName" name="ChoicesUserName" class="form-control" [formControl]="choicesNameForm" [(ngModel)]="choicesUsername" maxlength="60" (keyup)="this.validation.isAccountNameInvalid = this.checkIfEmpty(accountName);">
                  </div>
                </div>
              </div>
              <div class="form-group" *ngIf="importChoices">
                <div class="col-xs-12 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 col-lg-6 col-lg-offset-3 col-xl-6 col-xl-offset-3">
                  <label for="ChoicesPassword" class="control-label">Password</label>
                  <div class="input-tooltip">
                    <input type="password" id="ChoicesPassword" name="ChoicesPassword" class="form-control" [formControl]="choicesPasswordForm" [(ngModel)]="choicesPassword" maxlength="60" (keyup)="this.validation.isAccountNameInvalid = this.checkIfEmpty(accountName);">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default submit" style="margin:20px;">
        <div class="panel-body">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="isPrivacyPolicy">
              <div [ngClass]="{'has-error': (privacyPolicy.invalid && (privacyPolicy.dirty || privacyPolicy.touched || invalidForm))}">
                <fieldset>
                  <legend class="sr-only" aria-hidden="false">Privacy Policy</legend>
                  <div class="flex-item col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 checkbox-style" style="padding-left:14px;">
                    <input type="checkbox" id="privacyPolicy" name="privacyPolicy" [(ngModel)]="privacyPolicyValue" required #privacyPolicy="ngModel" [attr.aria-invalid]="(privacyPolicy.invalid && (privacyPolicy.dirty || privacyPolicy.touched || invalidForm))">
                    <label for="privacyPolicy">I have read and agree to the <a id="privacylink" href="/Home/privacy.aspx" target="_blank">privacy policy</a> and <a id="termslink" href="/Home/terms.aspx" target="_blank">terms of use</a> of this site. </label>
                    <div *ngIf="privacyPolicy.invalid && (privacyPolicy.dirty || privacyPolicy.touched || invalidForm)">
                      <p *ngIf="privacyPolicy.errors?.required" class="error-message"><i class="fa fa-times" aria-hidden="true"></i> Please read the privacy policy and terms of use for this website, then check the box to indicate your agreement.</p>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="text-align:center;">
              <button id="btn_submit" class="btn btn-primary btn-round btn-submit">
                Submit
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</form>
